import { render, staticRenderFns } from "./AssignArea.vue?vue&type=template&id=17f2b77e&scoped=true&"
import script from "./AssignArea.vue?vue&type=script&lang=js&"
export * from "./AssignArea.vue?vue&type=script&lang=js&"
import style0 from "./AssignArea.vue?vue&type=style&index=0&id=17f2b77e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f2b77e",
  null
  
)

export default component.exports